function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getAccHostname, getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
import { PRODUCT_IDS } from '@adsk/alloy-provider';
import { SERVICE_ACCESSES, SERVICES, COMPONENT_VARIANTS, TIME_ZONES, getConstructionApiUrl, formatDate } from '@adsk/acs-admin-ui-components-helpers';
import { TEMPLATE_PROJECT_TYPE, TEMPLATE_PROJECT_CLASSIFICATION, ACS_UNIFIED_SOURCE, ACTIVE_SERVICES } from './constants';
export var isDuplicateNameError = function isDuplicateNameError(errors) {
  var re = /^name:.+\sunique validation failed/i;
  return errors.some(function (error) {
    return error.field === 'name' && re.test(error.detail);
  });
};
export var getUserActiveIngServices = function getUserActiveIngServices(services) {
  return services.filter(function (_ref) {
    var status = _ref.status;
    return ACTIVE_SERVICES.includes(status);
  }).map(function (_ref2) {
    var serviceName = _ref2.serviceName;
    return {
      serviceName: serviceName,
      access: serviceName === SERVICES.PROJECT_ADMIN ? SERVICE_ACCESSES.ADMIN : SERVICE_ACCESSES.NONE
    };
  });
};
export var buildAccountServicesRequest = function buildAccountServicesRequest(accountId) {
  return "".concat(getAdminApiUrl(), "/v1/accounts/").concat(accountId, "?fields=services");
};
export var buildAccountsRequest = function buildAccountsRequest() {
  return "".concat(getAdminApiUrl(), "/v1/accounts?filter[accessLevels]=accountAdmin,accountStandardsAdministrator,projectAdmin&fields=name,accessLevels,hasAcsUnifiedProjects,isAccEligible,createProjectAccessLevels&limit=200");
};
export var buildTemplatesRequest = function buildTemplatesRequest(accountId, useConstructionApi) {
  var url = useConstructionApi ? getConstructionApiUrl() : getAdminApiUrl();
  var filters = useConstructionApi ? "&filter[classification]=".concat(TEMPLATE_PROJECT_CLASSIFICATION) : "&filter[source]=".concat(ACS_UNIFIED_SOURCE);
  return "".concat(url, "/v1/accounts/").concat(accountId, "/projects?filter[type]=").concat(TEMPLATE_PROJECT_TYPE).concat(filters, "&filter[status]=active&fields=name&limit=200");
};
export var buildCreateProjectRequest = function buildCreateProjectRequest(_ref3) {
  var accountId = _ref3.accountId,
    projectData = _ref3.projectData,
    _ref3$useConstruction = _ref3.useConstructionApi,
    useConstructionApi = _ref3$useConstruction === void 0 ? false : _ref3$useConstruction;
  var url = useConstructionApi ? getConstructionApiUrl() : getAdminApiUrl();
  return ["".concat(url, "/v1/accounts/").concat(accountId, "/projects"), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(projectData)
  }];
};
export var buildAddUserToProjectRequest = function buildAddUserToProjectRequest(_ref4) {
  var projectId = _ref4.projectId,
    userData = _ref4.userData,
    _ref4$useConstruction = _ref4.useConstructionApi,
    useConstructionApi = _ref4$useConstruction === void 0 ? false : _ref4$useConstruction;
  var url = useConstructionApi ? getConstructionApiUrl() : getAdminApiUrl();
  return ["".concat(url, "/v1/projects/").concat(projectId, "/users"), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(userData)
  }];
};
export var getProjectAdminConsoleTeamPageUrl = function getProjectAdminConsoleTeamPageUrl(_ref5) {
  var isEmsAccount = _ref5.isEmsAccount,
    projectId = _ref5.projectId,
    uiDomainUrl = _ref5.uiDomainUrl;
  if (isEmsAccount && uiDomainUrl) {
    return "".concat(uiDomainUrl, "/project-admin/members/projects/").concat(projectId, "?openCurrentUserProfilePanel=true");
  }
  return "".concat(getAccHostname(), "/project-admin/members/projects/").concat(projectId, "?openCurrentUserProfilePanel=true");
};
export var buildGetProjectUserRequest = function buildGetProjectUserRequest(projectId, userId, useConstructionApi) {
  var baseUrl = useConstructionApi ? getConstructionApiUrl() : getAdminApiUrl();
  return "".concat(baseUrl, "/v1/projects/").concat(projectId, "/users/").concat(userId);
};
var checkTimeZoneChanged = function checkTimeZoneChanged(selectedTimeZone) {
  var currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return currentTimeZone && TIME_ZONES.includes(currentTimeZone) ? (selectedTimeZone === null || selectedTimeZone === void 0 ? void 0 : selectedTimeZone.value) !== currentTimeZone : selectedTimeZone !== null;
};
export var dataEntered = function dataEntered(initialState, state, accountsCount) {
  var _state$selectedCurren;
  var additionalFieldsActivated = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var variant = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : COMPONENT_VARIANTS.PROJECT;
  var accountId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
  var templateId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;
  return variant === COMPONENT_VARIANTS.PROJECT && !accountId && state.selectedAccount !== null && accountsCount > 1 || state.projectName !== initialState.projectName || state.selectedProjectType !== initialState.selectedProjectType || state.autocompletedAddress !== initialState.autocompletedAddress || state.address.line1 !== initialState.address.line1 || state.address.line2 !== initialState.address.line2 || state.address.city !== initialState.address.city || state.address.stateOrProvince !== initialState.address.stateOrProvince || state.address.zip !== initialState.address.zip || state.address.country !== initialState.address.country || state.selectedTemplate !== initialState.selectedTemplate && !templateId || state.startDate !== initialState.startDate || state.endDate !== initialState.endDate || additionalFieldsActivated && (state.jobNumber !== initialState.jobNumber || checkTimeZoneChanged(state.selectedTimeZone) ||
  // state.selectedPhase !== initialState.selectedPhase ||
  state.projectValue !== initialState.projectValue || ((_state$selectedCurren = state.selectedCurrency) === null || _state$selectedCurren === void 0 ? void 0 : _state$selectedCurren.value) !== initialState.selectedCurrency.value);
};
export var validProjectValue = function validProjectValue(value) {
  var regInteger = /^\d+$/;
  return value !== '' ? regInteger.test(value) : true;
};
export var validateDate = function validateDate(data) {
  var date = data && data.date ? data.date : null;
  return date;
};
export var getProjectData = function getProjectData(state, additionalFieldsActivated, useConstructionApi) {
  var address = state.address,
    endDate = state.endDate,
    globalTemplateIds = state.globalTemplateIds,
    jobNumber = state.jobNumber,
    projectName = state.projectName,
    projectValue = state.projectValue,
    selectedCurrency = state.selectedCurrency,
    selectedProjectType = state.selectedProjectType,
    selectedTemplate = state.selectedTemplate,
    selectedTimeZone = state.selectedTimeZone,
    startDate = state.startDate;
  var servicesOrDefaultEmptyProducts = useConstructionApi ? {} : {
    services: Object.values(SERVICES).map(function (serviceName) {
      return {
        serviceName: serviceName
      };
    })
  };
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    name: projectName,
    type: (selectedProjectType === null || selectedProjectType === void 0 ? void 0 : selectedProjectType.value) || ''
  }, !useConstructionApi && {
    isAcsUnified: true
  }), startDate && {
    startDate: formatDate(startDate)
  }), endDate && {
    endDate: formatDate(endDate)
  }), address.addressLine1 && {
    addressLine1: address.addressLine1
  }), address.addressLine2 && {
    addressLine2: address.addressLine2
  }), address.city && {
    city: address.city
  }), address.stateOrProvince && {
    stateOrProvince: address.stateOrProvince
  }), address.postalCode && {
    postalCode: address.postalCode
  }), address.country && {
    country: address.country
  }), selectedTemplate ? {
    template: {
      projectId: selectedTemplate.id,
      isSampleProjectTemplate: globalTemplateIds && globalTemplateIds.includes(selectedTemplate.id)
    }
  } : servicesOrDefaultEmptyProducts), additionalFieldsActivated && _objectSpread(_objectSpread(_objectSpread({}, jobNumber && {
    jobNumber: jobNumber
  }), selectedTimeZone && {
    timezone: selectedTimeZone.value
  }), projectValue && {
    projectValue: {
      value: parseFloat(projectValue),
      currency: selectedCurrency.value
    }
  }));
};
export var getAdminUserAccess = function getAdminUserAccess(useConstructionApi, services, products) {
  var useTurnOnPurchasedProductsFF = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (useConstructionApi) {
    if (useTurnOnPurchasedProductsFF) {
      return products.filter(function (product) {
        return product.userAssignable && product.included || product.type === PRODUCT_IDS.PROJECT_ADMINISTRATION;
      }).map(function (product) {
        return {
          key: product.type,
          access: SERVICE_ACCESSES.ADMIN
        };
      });
    }
    return [{
      key: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      access: SERVICE_ACCESSES.ADMIN
    }];
  }
  return getUserActiveIngServices(services);
};
export var buildGetProjectRolesRequest = function buildGetProjectRolesRequest(projectId) {
  var baseUrl = getAdminApiUrl();
  return "".concat(baseUrl, "/v1/projects/").concat(projectId, "/roles");
};
//# sourceMappingURL=utils.js.map